import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./SideBarMenu.scss";
import { HiArrowDown } from "react-icons/hi2";

export default function SideBarMenu({ SideBarLinks }) {
  const [openDropdown, setOpenDropdown] = useState(false);

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };
  return (
    <div className="sidebar-menu">
      {SideBarLinks.map((link) => (
        <>
          {link.href ? (
            <NavLink
              to={link.href}
              key={link.name}
              className="sidebar-menu__link"
            >
              {link.icon}
              <span>{link.name}</span>
            </NavLink>
          ) : (
            <>
              <button
                className="sidebar-menu__link"
                onClick={() => toggleDropdown(link.name)}
              >
                {link.icon}
                <span>{link.name}</span>
                <div
                  className={`arrow ${
                    openDropdown === link.name ? "open" : ""
                  }`}
                >
                  <HiArrowDown />
                </div>
              </button>
              {openDropdown === link.name && (
                <div className="sidebar-menu__sublink-content">
                  {link.subLinks.map((subLink) => (
                    <NavLink
                      to={subLink.href}
                      key={subLink.name}
                      className="sidebar-menu__sublink"
                    >
                      <span>{subLink.name}</span>
                    </NavLink>
                  ))}
                </div>
              )}
            </>
          )}
        </>
      ))}
    </div>
  );
}
